
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: "filinglist",
components: {Tab, TabItem, Group, Cell, XButton},
data() {
return {
dataList: [],
total: 0,
header: {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
},
type: false
}
},
methods: {
goToFiling() {
this.$router.push({name: 'filing'})
},
init(info) {
switch (info['state']) {
case 'COMPLETE':
info['state'] = '备案待补充'
break
case 'AUDIT':
info['state'] = '备案待审批'
break
case 'REAUDIT':
info['state'] = '重新备案,待审批'
break
case 'ASUCCESS':
info['state'] = '备案审批通过'
break
case 'AFAIL':
info['state'] = '备案审批失败'
break
case 'REWARD':
info['state'] = '备案等待奖励审批'
break
case 'RSUCCESS':
info['state'] = '奖励审批通过'
break
case 'RFAIL':
info['state'] = '奖励审批失败'
break
case 'EXPIRED':
info['state'] = '备案超时'
break
default:
break
}
return info
},
toAudit() {
this.type = false
this.$http.get('/api/v1/srvp_projects?role=INDV&offset=0&count=10&closed=false&company=北京中广上洋科技股份有限公司', this.header)
.then(response => {
this.dataList = response.data.content.map((item) => {
return this.init(item)
})
this.total = response.data.total
})
.catch(error => {
this.$vux.toast.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
})
},
auditEd() {
this.type = true
this.$http.get('/api/v1/srvp_projects?role=INDV&offset=0&count=10&closed=true&company=北京中广上洋科技股份有限公司', this.header)
.then(response => {
this.dataList = response.data.content.map((item) => {
return this.init(item)
})
this.total = response.data.total
})
.catch(error => {
this.$vux.toast.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
})
},
more() {
this.$http.get('/api/v1/srvp_projects?role=INDV&offset=' + this.dataList.length + '&count=10&closed=' + this.type + '&company=北京中广上洋科技股份有限公司', this.header)
.then(response => {
this.dataList = [...this.dataList, ...response.data.content].map(item => {
return this.init(item)
})
this.total = response.data.total
})
.catch(error => {
this.$vux.toast.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
})
}
},
created() {
let unionid = localStorage.getItem('unionid')
this.$http.get('api/v1/wechat/' + unionid).then((res) => {



let len = res.data.length
if (len) {
let account = res.data[0].account
localStorage.setItem('account', account)
this.$http.post('api/v1/wechat/' + unionid + '/token', {'account': account}).then((res) => {
localStorage.setItem('token', res.data.token)
localStorage.setItem('userid', res.data.userid)
this.header = {
headers: {
token: res.data.token,
opid: res.data.userid
}
}
this.toAudit();
})
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/srvpproject/filinglist.vue